<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" />
      <el-form
        label-width="80px"
        :model="financeForm"
        :rules="financeFormRules"
        ref="financeFormRef"
        v-if="isChinese === 'zh-cn'"
      >
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.bankAccount')"
          label-width="400px"
          prop="bankId"
        >
          <!-- 银行账号 -->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.bankAccountMsg')"
            v-model="financeForm.bankId"
            maxlength="25"
            @keyup.native="bankIdKeyup()"
            @input.native="bankIdInput()"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.depositBank')"
          label-width="400px"
          prop="bankName"
        >
          <!-- 开户银行 -->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.depositBankMsg')"
            v-model="financeForm.bankName"
            maxlength="100"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        label-width="80px"
        :model="financeForm1"
        :rules="financeFormRules1"
        ref="financeFormRef1"
        v-else
      >
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.bankAccountName')"
          label-width="400px"
        >
          <!-- prop="accountName"银行账号名称 -->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.bankAccountNameMsg')"
            v-model="financeForm1.accountName"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.bankAccount')"
          label-width="400px"
        >
          <!-- prop="bankId" 银行账号-->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.bankAccountMsg')"
            v-model="financeForm1.bankId"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.depositBank')"
          label-width="400px"
        >
          <!-- prop="bankName"开户银行 -->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.depositBankMsg')"
            v-model="financeForm1.bankName"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.bankAddress')"
          label-width="400px"
        >
          <!-- prop="银行地址accountBankAddr" -->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.bankAddressMsg')"
            v-model="financeForm1.accountBankAddr"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.beneficiary')"
          label-width="400px"
        >
          <!-- prop="payeeAddr" 收款人地址-->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.beneficiaryMsg')"
            v-model="financeForm1.payeeAddr"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.swiftCode')"
          label-width="400px"
        >
          <!-- prop="swiftCode" 银行国际代码-->
          <el-input
            :placeholder="$t('page.financeInfo.inputPlc.swiftCodeMsg')"
            v-model="financeForm1.swiftCode"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.financeInfo.contentLabel.isWhether')"
          label-width="400px"
          prop="isAccp"
        >
          <!-- prop="swiftCode" 是否接受信用证付款-->
          <el-radio-group v-model="financeForm1.isAccp">
            <el-radio :label="1" value="是">{{
              $t("page.supInfo.inputPlc.yes")
            }}</el-radio>
            <el-radio :label="0" value="否">{{
              $t("page.supInfo.inputPlc.no")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {saveSupplierRegistInfo,qrySupRegistFinanceInfo} from '../../../api/supRegister'
import bus from '@/basa/utils/msgBus'
import {mapActions} from 'vuex'
import Setting from "@/setting/setting";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;


export default {
  name: "financialInformation",
  data() {
    return {
      title: window.$t('page.financeInfo.contentTitle.financeInfo'),     // 财务信息
      // 表单数据
      financeForm: {
        bankId: '',
        bankName: ''
      },
      financeForm1: {
        accountName: '',
        bankId: '',
        bankName: '',
        accountBankAddr: '',
        payeeAddr: '',
        swiftCode: '',
        isAccp: ''
      },
      // 表单校验规则
      financeFormRules: {
        bankId: [{ required: true, message: window.$t('page.financeInfo.inputPlc.bankAccountMsg'), trigger: 'blur' },],
        bankName: [{ required: true, message: window.$t('page.financeInfo.inputPlc.depositBankMsg'), trigger: 'blur' }],
      },
      financeFormRules1: {
        accountName: [{required: true,message: '请输入银行账户名称',trigger: 'blur'}],
        bankId: [{required: true,message: '请输入银行账号',trigger: 'blur'}],
        bankName: [{required: true,message: '请输入银行名称',trigger: 'blur'}],
        accountBankAddr: [{required: true,message: '请输入银行地址',trigger: 'blur'}],
        payeeAddr: [{required: true,message: '请输入受益人地址',trigger: 'blur'}],
        swiftCode: [{required: true,message: '请输入快捷代码',trigger: 'blur'}],
        isAccp: [{required: window.languagezh_cn?false:true,message: window.$t('page.financeInfo.inputPlc.isWhetherMsg'),trigger: 'change'}],
      },
      supInfoApplyId: '',
      isChinese: Cookies.get(savedLocaleKey) || 'zh-cn'
    }
  },
  created() {
    if(this.$route.query.page) {
      this.changeCheckPage(7)
    }
    if(Cookies.get('access_token') || this.$route.query.tempSupinfoId){
      this.getSupRegistFinanceInfo()
    }
    if(this.$route.path == '/maPerfectInfo/financialInformation'){
      this.changeCheckPage(7)
     for(let i = 0; i < 4; i++){
        this.msgCenter.$emit('ballMoveRight')
      }
    }
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    back() {
      this.changeCheckPage(6)
      this.$router.push({path:'/maPerfectInfo/productInformation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
    },
    next() {
      if(this.isChinese === 'zh-cn') {
        this.$refs.financeFormRef.validate(async valid => {
          if(valid) {
            // this.$emit('next')
            try {
              const {data} = await saveSupplierRegistInfo({
                dataSourceFlag: 0,
                isOverseas: 0,
                tempSupinfoId: this.supInfoApplyId,
                // supCode: '',
                saveOrCommitFlag: '2',
                supRegistTab: '8',
                supRegistPayInfoBO: this.financeForm,
                isShowLoading:true,
              })
              console.log(data)
              if(data.code == 0) {
                this.changeCheckPage(8)
                this.$router.push({path:'/maPerfectInfo/historyCooperation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
              }
            } catch (err) {
              console.log(err.data.message)
            }
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName('is-error');
              isError[0].querySelector('input').focus();
            },100)
            return false
          }
        })
      } else {
        this.$refs.financeFormRef1.validate(async valid => {
          if(valid) {
            // this.$emit('next')
            try {
              const {data} = await saveSupplierRegistInfo({
                dataSourceFlag: 0,
                isOverseas: window.languagezh_cn?0:1,
                tempSupinfoId: this.supInfoApplyId,
                // supRegistAccountInfoBO:{
                //   countyCode:sessionStorage.getItem('countyCode'),
                //   countyName:sessionStorage.getItem('countyName'),
                // },
                // supCode: '',
                saveOrCommitFlag: '2',
                isShowLoading:true,
                supRegistTab: '8',
                supRegistPayInfoBO: this.financeForm1
              })
              console.log(data)
              if(data.code == 0) {
                this.changeCheckPage(8)
                this.$router.push({path:'/maPerfectInfo/qualificationDocuments',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
              }
            } catch (err) {
              console.log(err.data.message)
            }
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName('is-error');
              isError[0].querySelector('input').focus();
            },100)
            return false
          }
        })
      }
    },
    // 获取财务信息
    async getSupRegistFinanceInfo() {
      const {data} = await qrySupRegistFinanceInfo({
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
        supInfoApplyId: this.$route.query.tempSupinfoId,
        isShowLoading:true,
      })
      console.log(data)
      if(data.code === '0') {
        if(this.isChinese === 'zh-cn') {
          this.financeForm.bankId = data.data.supRegistPayInfoBO.bankId
          this.financeForm.bankName = data.data.supRegistPayInfoBO.bankName
        } else {
          this.financeForm1.bankId = data.data.supRegistPayInfoBO.bankId
          this.financeForm1.bankName = data.data.supRegistPayInfoBO.bankName
          this.financeForm1.accountName = data.data.supRegistPayInfoBO.accountName
          this.financeForm1.accountBankAddr = data.data.supRegistPayInfoBO.accountBankAddr
          this.financeForm1.payeeAddr = data.data.supRegistPayInfoBO.payeeAddr
          this.financeForm1.swiftCode = data.data.supRegistPayInfoBO.swiftCode
          this.financeForm1.isAccp = data.data.supRegistPayInfoBO.isAccp
        }
        this.supInfoApplyId = data.data.supInfoApplyId
      }
    },
    bankIdKeyup(){
      this.financeForm.bankId = this.financeForm.bankId.replace(/[^\d]/g,'')
    },
    bankIdInput(){
      this.financeForm.bankId = this.financeForm.bankId.replace(/[^\d]/g,'')
    }
  }
}
</script>

<style scoped lang="scss">
.sign-content {
  width: 1180px;
  height: 450px;
  background: #FFFFFF;
 margin: 20px auto;
  overflow: hidden;

  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
      margin-left: 230px;
    }
  }
  .el-form {
    margin-top: 26px;
    //margin-left: 281px;
    .el-input {
      margin-left: 6px;
      width: 430px;
    }
    .el-radio-group {
      margin-left: 6px;
    }
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  border-color: #ff142f;

  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btn:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}
/deep/.el-form .el-input__inner:focus{
  border-color:#FF142F;
}
/deep/.el-input__inner:focus{
  color: #FF142F;
  border:1px solid #FF142F;
}
</style>
